import { Typography } from '@mui/material';
import { CreateArtRequest, UploadPhotoFormData } from 'modules/art/types';
import { FC } from 'react';
import { useLangContext } from 'shared/features/Language';
import { PublicPageLayout } from 'shared/layout';
import { UploadPhotoForm2 } from './UploadPhotoForm2';

type Props = {
  initForm: Omit<CreateArtRequest, 'image'>;
  uploadImage: (form: UploadPhotoFormData & Omit<CreateArtRequest, 'image'>) => void;
};

export const UploadPhotoView2: FC<Props> = ({ initForm, uploadImage }) => {
  const { textData } = useLangContext();

  return (
    <PublicPageLayout
      title={
        <Typography
          variant="subtitle1"
          sx={{
            maxWidth: '394px',
            paddingRight: {
              sm: '20px ',
              xs: '20px ',
            },
            fontSize: {
              md: '50px',
              xs: '30px',
            },
            lineHeight: {
              md: '60px',
              xs: '36px',
            },
          }}
        >
          {textData.uploadPageTitle}
        </Typography>
      }
    >
      <UploadPhotoForm2 initForm={initForm} submit={uploadImage} />
    </PublicPageLayout>
  );
};
